import { Injectable } from '@angular/core';
import { GetTimestampFromTime } from '@dave/types';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { MaterialAmountEntityFromBackend } from '../../entities/material-amount.entity';
import { AppGatewayService } from '../../services/app-gateway.service';
import { DaveActions } from '../actions/actions';
import { BaseActionTypes } from '../actions/base.actions';
import { MaterialAmountActionTypes } from '../actions/material-amount.actions';
import { State } from '../index';
import { getMaterialAmountDictionary } from '../selectors/material-amount.selectors';

enum ErrorCodes {
    Load = 'MaterialAmount Abrufen fehlgeschlagen',
}

@Injectable()
export class MaterialAmountEffects {
    constructor(private actions$: Actions<DaveActions>, private store$: Store<State>, private gatewayService: AppGatewayService) {}

    LoadMaterialAmounts$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(MaterialAmountActionTypes.Load),
                switchMap(({ Payload }) => {
                    return this.gatewayService
                        .Request({ ErpMaterialAmountGet: Payload })
                        .then((res) => {
                            if (Object.keys(res?.Errors || {}).length === 0) {
                                if (res.ErpMaterialAmountGet.MaterialAmounts) {
                                    firstValueFrom(this.store$.select(getMaterialAmountDictionary)).then((MaterialAmounts) => {
                                        const fRes = res.ErpMaterialAmountGet.MaterialAmounts.filter((MaterialAmount) => {
                                            const fromState = MaterialAmounts[MaterialAmount.MaterialId + '|' + MaterialAmount.WarehouseMovementId];
                                            return !fromState || GetTimestampFromTime(fromState.CreatedAt).toString() !== MaterialAmount.CreatedAt;
                                        });
                                        if (fRes.length) {
                                            this.store$.dispatch(
                                                MaterialAmountActionTypes.UpdateMany({
                                                    Payload: fRes.map((val) => MaterialAmountEntityFromBackend(val)),
                                                    updateLatestUpdatedAt: true,
                                                }),
                                            );
                                        }
                                    });
                                }
                            } else {
                                throw res.Errors;
                            }
                        })
                        .catch((err) => {
                            this.store$.dispatch(
                                BaseActionTypes.ErrorAction({
                                    Payload: {
                                        ToasterMessage: ErrorCodes.Load,
                                        Err: err,
                                    },
                                }),
                            );
                            // return EMPTY;
                        });
                }),
            );
        },
        { dispatch: false },
    );

    error$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MaterialAmountActionTypes.LoadFailure),
            map(({ Payload }) =>
                BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: Payload.ToasterMessage,
                        Err: Payload.Errors,
                    },
                }),
            ),
        ),
    );
}
